import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { NOTIFICATIONS_DRAWER_LOG_MODULE } from '../../../RealtimeNotifications/shared/constants';
import { logError } from '../../../shared/logError';

const filename = 'notifications_drawer_package/src/api/toggleRead/index.js';
const message = 'Failed toggling item state';

export const paths = {
    markNotificationUnread: pathfinder('mark_notifications_item_as_unread'),
    markNotificationRead: pathfinder('mark_notifications_item_as_read'),
    markConversationUnread: pathfinder('mark_as_unread_conversations'),
    markConversationRead: pathfinder('mark_as_read_conversations'),
};

export const markNotificationUnread = async (id) => {
    try {
        const result = await axios({
            url: paths.markNotificationUnread,
            method: 'POST',
            data: { id },
        });

        return result;
    } catch (error) {
        logError(error, {
            module: NOTIFICATIONS_DRAWER_LOG_MODULE,
            payload: {
                filename,
                url: paths.markNotificationUnread,
                action: 'markNotificationUnread',
                message,
            },
        });
    }
};

export const markNotificationRead = async (id) => {
    try {
        const result = await axios({
            url: paths.markNotificationRead,
            method: 'POST',
            data: { id },
        });

        return result;
    } catch (error) {
        logError(error, {
            filename,
            url: paths.markNotificationRead,
            action: 'markNotificationRead',
            message,
        });
    }
};

export const markConversationUnread = async (id) => {
    try {
        const result = await axios({
            url: paths.markConversationUnread,
            method: 'POST',
            data: { id },
        });

        return result;
    } catch (error) {
        logError(error, {
            filename,
            url: paths.markConversationUnread,
            action: 'markConversationUnread',
            message,
        });
    }
};

export const markConversationRead = async (id) => {
    try {
        const result = await axios({
            url: paths.markConversationRead,
            method: 'POST',
            data: { id },
        });

        return result;
    } catch (error) {
        logError(error, {
            filename,
            url: paths.markConversationRead,
            action: 'markConversationRead',
            message,
        });
    }
};
